import { LegalLayout, H2, H3, P, Strong, UL, LI, Table } from "@/components/legal/LegalLayout";

const CookiesPage = () => (
  <LegalLayout
    title="Politique de gestion des cookies"
    subtitle="Dernière mise à jour : 26 août 2026"
  >
    <H2>1. Qu&apos;est-ce qu&apos;un cookie ?</H2>
    <P>
      Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, tablette, smartphone) lors de la visite d&apos;un site internet. Il permet au site de vous reconnaître, de mémoriser vos préférences, ou de mesurer l&apos;audience.
    </P>

    <H2>2. Cookies utilisés sur ce site</H2>

    <H3>Cookies techniques (obligatoires, sans consentement)</H3>
    <P>Ces cookies sont indispensables au bon fonctionnement du site. Ils ne peuvent pas être désactivés.</P>
    <Table
      head={["Nom", "Finalité", "Durée"]}
      rows={[
        ["session_id", "Maintenir votre session pendant la navigation", "Session"],
        ["cookie_consent", "Mémoriser vos choix de consentement", "6 mois"],
        ["csrf_token", "Sécurité anti-attaque", "Session"],
      ]}
    />

    <H3>Cookies analytiques (soumis à consentement)</H3>
    <P>Ces cookies nous permettent de mesurer l&apos;audience du site et de l&apos;améliorer.</P>
    <Table
      head={["Fournisseur", "Finalité", "Durée", "Transfert"]}
      rows={[
        ["Google Analytics 4 (_ga, _ga_*)", "Statistiques de fréquentation anonymes", "13 mois", "États-Unis (Data Privacy Framework)"],
      ]}
    />

    <H3>Cookies publicitaires (soumis à consentement)</H3>
    <P>Ces cookies permettent de mesurer l&apos;efficacité de nos publicités sur les réseaux sociaux.</P>
    <Table
      head={["Fournisseur", "Finalité", "Durée", "Transfert"]}
      rows={[
        ["Meta Pixel (_fbp, fr)", "Mesure et optimisation des campagnes Meta (Facebook, Instagram)", "13 mois", "États-Unis (clauses contractuelles types)"],
      ]}
    />

    <H2>3. Comment gérer vos cookies ?</H2>
    <P>Lors de votre première visite, un bandeau vous permet de :</P>
    <UL>
      <LI>Tout accepter</LI>
      <LI>Tout refuser (accès aussi facile que « Tout accepter »)</LI>
      <LI>Personnaliser vos choix par catégorie</LI>
    </UL>
    <P>Vous pouvez modifier vos choix à tout moment en cliquant sur le lien « Gérer mes cookies » présent en bas de chaque page.</P>

    <H2>4. Cookies déposés par les navigateurs</H2>
    <P>Vous pouvez également configurer votre navigateur pour refuser tous les cookies :</P>
    <UL>
      <LI>Chrome : Paramètres → Confidentialité et sécurité → Cookies</LI>
      <LI>Firefox : Paramètres → Vie privée et sécurité</LI>
      <LI>Safari : Préférences → Confidentialité</LI>
      <LI>Edge : Paramètres → Cookies et autorisations de site</LI>
    </UL>
    <P><Strong>Attention :</Strong> la désactivation totale des cookies peut altérer le fonctionnement du site.</P>

    <H2>5. Durée de conservation du consentement</H2>
    <P>Vos choix de consentement sont conservés pendant 6 mois. Passé ce délai, le bandeau vous sera de nouveau présenté conformément aux recommandations de la CNIL.</P>

    <H2>6. Contact</H2>
    <P>Pour toute question relative aux cookies : <a href="mailto:walid.societe.pro@gmail.com" style={{ color: "#B8977E" }}>walid.societe.pro@gmail.com</a></P>
  </LegalLayout>
);

export default CookiesPage;
